import { useState } from "react";
import { useIntl } from "react-intl";

import { Button } from "@/components/Button/Button";
import { DrawerTopBarWithAction } from "@/components/Drawer/DrawerTopBar";
import { PriceRangeSlider } from "@/components/Sliders/PriceRangeSlider";
import type { IHotelsFilters } from "@/features/hotels/types/types";

type Props = {
  defaultFilters: IHotelsFilters;
  filters: IHotelsFilters;
  bookingNights: number;
  onApply: (newPriceRange: [number, number]) => void;
  onClose: () => void;
};

export function PriceFilterDrawer({
  defaultFilters,
  filters,
  bookingNights,
  onApply,
  onClose,
}: Props) {
  const intl = useIntl();
  const nights = Math.max(1, bookingNights);
  const [localPriceRange, setLocalPriceRange] = useState<[number, number]>(
    filters.priceRange,
  );

  return (
    <>
      <DrawerTopBarWithAction
        onCloseClick={onClose}
        title={intl.formatMessage({
          defaultMessage: "Price",
          description: "Title for the price filter drawer",
        })}
      />

      <p className="mt-4 text-lg font-medium">
        {intl.formatMessage({
          defaultMessage: "Price (per night)",
          description:
            "Label for the price range slider in hotel filters, indicating that the price is calculated per night",
        })}
      </p>

      <div className="-mx-main my-4 px-main">
        <PriceRangeSlider
          min={defaultFilters.priceRange[0]}
          max={defaultFilters.priceRange[1]}
          value={[localPriceRange[0], localPriceRange[1]]}
          scale={(value) => value / nights}
          descale={(value) => Math.round(value * nights)}
          onChange={(newValue) => {
            setLocalPriceRange(newValue);
          }}
        />
      </div>

      <div className="-mx-main border-t border-t-stroke-neutral-soft px-main pt-4">
        <Button
          fullWidth
          onClick={() => {
            onApply(localPriceRange);
            onClose();
          }}
          variant="contained"
          size="large"
        >
          {intl.formatMessage({
            defaultMessage: "Apply",
            description: "Button to apply selected filters or changes",
          })}
        </Button>
      </div>
    </>
  );
}
